import { ChangeEvent } from 'react';
import { Filters as FiltersType } from '@/domain';

type PropertyTypeFilterProps = {
    propertyTypes?: string[];
    onFilterChanged: (filters: FiltersType) => void;
};

const propertyTypesList = [
    { name: 'Leilighet', id: '1' },
    { name: 'Hytte/Feriehjem', id: '2' },
    { name: 'Bobil og campingvogn', id: '3' },
    { name: 'Båt', id: '4' },
    { name: 'Campinghytte', id: '5' },
    { name: 'Enkeltrom', id: '6' },
    { name: 'Gård', id: '7' },
    { name: 'Hus', id: '8' },
    { name: 'Lavvo', id: '9' },
    { name: 'Rorbu', id: '10' },
    { name: 'Tretopphytte', id: '11' },
];

export const PropertyTypeFilter = ({ propertyTypes = [], onFilterChanged }: PropertyTypeFilterProps) => {
    const handleChange = ({ target: { checked, value: id } }: ChangeEvent<HTMLInputElement>): void => {
        const checkedPropertyTypes = propertyTypes.filter((propertyId) => propertyId !== id);

        if (checked) {
            checkedPropertyTypes.push(id);
        }

        onFilterChanged({ property_types: checkedPropertyTypes });
    };

    return (
        <>
            {propertyTypesList.map(({ name, id }) => (
                <div className="input-toggle" key={id}>
                    <input
                        type="checkbox"
                        id={`property_type_${id}`}
                        data-testid={`property_type_${id}`}
                        value={id}
                        checked={propertyTypes.includes(id)}
                        onChange={handleChange}
                    />
                    <label htmlFor={`property_type_${id}`}>{name}</label>
                </div>
            ))}
        </>
    );
};
